export const CATEGORY_SEARCH = 'CATEGORY_SEARCH'
export const CLASSIC_SEARCH = 'CLASSIC_SEARCH'
